"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCanonicalUrl = void 0;
__exportStar(require("./clock"), exports);
__exportStar(require("./create-rewrites"), exports);
__exportStar(require("./create-routing"), exports);
var url_builders_1 = require("./factories/url-builders");
Object.defineProperty(exports, "buildCanonicalUrl", { enumerable: true, get: function () { return url_builders_1.buildCanonicalUrl; } });
__exportStar(require("./group-resolution"), exports);
__exportStar(require("./guards"), exports);
__exportStar(require("./localized-slugs"), exports);
__exportStar(require("./pages"), exports);
__exportStar(require("./segments"), exports);
__exportStar(require("./validators"), exports);
